import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import '../css/About.css';
import '../css/AddVehicle.css';
import { Row } from 'react-bootstrap';
import CityApi from '../../functions/api/partner/CityApi';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import ConvertCity from '../../functions/ConvertCity';
import NotifyError from '../../components/Notify/NotifyError';

class FormAddCity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      city_name: '',
      city_name_en: '',
      city_code: '',
      city_location: '',
      city_lat: '',
      city_long: '',
      city_popular: 0,
      isEdit: false,
    };
  }

  componentDidMount = async () => {
    if (
      this.props.match.params &&
      this.props.match.path == '/region/edit-city/:city_id'
    ) {
      const { city_id } = this.props.match.params;
      const detail = await CityApi.getById(city_id);
      console.log('detail ', detail);
      this.setState(detail);
      this.setState({ isEdit: true });
    }
  };

  handleChange = async (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangePopular = async (cityPolular) => {
    this.setState({ city_popular: cityPolular });
  };

  clearForm = () => {
    this.setState({
      city_name: '',
      city_name_en: '',
      city_code: '',
      city_location: '',
      city_lat: '',
      city_long: '',
      city_popular: 0,
      isEdit: false,
    });
  };

  handleCreate = async () => {
    const check = ConvertCity.handleCheck(this.state);
    console.log('check ', check);
    if (!check) {
      const city = ConvertCity.handleNew(this.state);
      let result = '';
      if (this.state.isEdit) {
        result = await CityApi.update(city);
      } else result = await CityApi.create(city);
      console.log('result ', result);
      if (result && !result.message) {
        var message = '';
        if (this.state.isEdit) message = 'Sửa thành phố thành công!';
        else message = 'Thêm thành phố thành công';

        NotifyAlert('Thành công', message);
        if (!this.state.isEdit) this.clearForm();
      } else {
        NotifyError('Lỗi', result.message);
      }
    } else {
      NotifyAlert(
        'Thông báo',
        `Dữ liệu bạn nhập còn thiếu :${check[0]} là bắt buộc`
      );
    }
  };

  render() {
    const {
      city_name,
      city_code,
      city_name_en,
      city_location,
      city_popular,
      city_lat,
      city_long,
    } = this.state;
    return (
      <div>
        <div
          style={{
            display: 'inline-flex',
            width: '90%',
            margin: '10px 10px 20px 21px',
          }}
        >
          <Link to="/region">
            <div className="button-back button">
              <img
                alt="Quay lại"
                src="ic_back.png"
                style={{ height: '20px' }}
              />
              <div style={{ fontSize: '16px' }}>Quay lại</div>
            </div>
          </Link>
          <div
            style={{
              color: '#107d82',
              fontWeight: '600',
              fontSize: '20px',
              marginLeft: '30%',
            }}
          >
            {this.state.isEdit ? 'Sửa thành phố' : 'Thêm thành phố'}
          </div>
        </div>

        <div
          style={{ backgroundColor: '#ececec', margin: '5px 20px 20px 20px' }}
        >
          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Tên thành phố</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="city_name"
                value={city_name}
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">
                Tên thành phố theo tiếng anh
              </div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="city_name_en"
                value={city_name_en}
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Mã thành phố</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="city_code"
                value={city_code}
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Thuộc khu vực</div>
              <select
                name="city_location"
                id="city_location"
                value={city_location}
                onChange={this.handleChange}
                className="input-normal full-width"
              >
                <option value="0" selected>
                  Chọn khu vực
                </option>
                <option value="mb">Miền Bắc</option>
                <option value="mt">Miền Trung</option>
                <option value="mn">Miền Nam</option>
              </select>
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Latitude</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="city_lat"
                value={city_lat}
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Longitude</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="city_long"
                value={city_long}
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page ">Thành phố nổi bật</div>
              <Switch
                onChange={(cityPolular) =>
                  this.handleChangePopular(cityPolular)
                }
                checked={city_popular}
                id="city_popupar"
                name="city_popupar"
              />
            </div>
          </Row>
        </div>

        <Row
          style={{
            display: 'inline-flex',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <div
            className="btn-edit button btn-save"
            style={{ background: '#107d82' }}
            onClick={this.handleCreate}
          >
            Lưu thay đổi
          </div>
        </Row>
      </div>
    );
  }
}

export default FormAddCity;
